import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBox,
  FDPaper,
  FDSecondaryActionButton,
  FDTable,
  FDTableBody,
  FDTableCell,
  FDTableHead,
  FDTableRow,
} from '@facet-wealth/design';
import { downloadSecureFileFromLink } from 'Helpers/File';

export function NMARSRequestsDesktop({ resource }) {
  const requests = useMemo(() => resource.attr('requests').resources().list(), [resource]);
  const fields = useMemo(() => requests[0]?.meta()?.template()?.list(), [requests]);
  return (
    <FDBox paddingY={2}>
      <FDPaper padding={4} appearance={'elevated'}>
        <FDTable>
          <FDTableHead>
            <FDTableRow>
              {fields?.map(field => <FDTableCell key={field.attr('name')}>{field.attr('prompt')}</FDTableCell>)}
              <FDTableCell>Download</FDTableCell>
            </FDTableRow>
          </FDTableHead>
          <FDTableBody>
            {requests?.map(request => (
              <FDTableRow key={request.id()}>
                {fields?.map(field => <FDTableCell key={field.attr('name')}>{request.attr(field.attr('name'))}</FDTableCell>)}
                <FDTableCell>
                  {
                    request.withRelationship(
                      fr.relationships.recommendations.name,
                      (rel) => (
                        <FDSecondaryActionButton
                          onClick={() => {
                            downloadSecureFileFromLink(rel.link('related'), rel.meta('title'));
                          }}
                          label="Download"
                        />
                      ),
                      () => null,
                    )
                  }
                </FDTableCell>
              </FDTableRow>
            ))}
          </FDTableBody>
        </FDTable>
      </FDPaper>
    </FDBox>
  );
}

NMARSRequestsDesktop.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
